import { useDispatch } from "react-redux";
import { appraisalSlice, getVehicle } from "../store/slices/Appraisal";
import { useSourceSystem } from "./useSourceSystem";
import {
  isErrorBlockedRegistration,
  isErrorVehicleNotEligibleForValuation,
  isErrorVehicleNotFound,
  isErrorVehicleCapDataNotFound
} from "../errors";

export const useVehicle = () => {
  const { sourceSystem } = useSourceSystem();
  const dispatch = useDispatch();
  const fetchVehicle = (registration, appraisalSessionId) => {
    const args = { registration, appraisalSessionId };

    const vehiclePromise = dispatch(getVehicle(args)).then((response) => {
      const errorCode = response?.payload?.error?.code;
      if (errorCode) {
        if (isErrorVehicleNotFound(errorCode) || isErrorVehicleCapDataNotFound(errorCode)) {
          sourceSystem.handleVehicleNotFoundError();
        } else if (isErrorVehicleNotEligibleForValuation(errorCode)) {
          sourceSystem.handleIneligibleVehicleError();
        } else if (isErrorBlockedRegistration(errorCode)) {
          dispatch(appraisalSlice.actions.setIsBlockedRegistration(true));
          sourceSystem.handleBlockedRegistration();
        }
      } else {
        const vehicle = response?.payload?.result;
        if (vehicle?.onlineValuationObtainable === false) {
          sourceSystem.handleUnableToValueError(vehicle, appraisalSessionId);
        }
      }
      return response;
    });

    return vehiclePromise;
  };

  return { fetchVehicle };
};
